"use strict";
import React from "react";
import _ from "underscore";
import ReactUtils from "../../react_utils";
import Api from "../../api/api";
const bem = ReactUtils.makeBem("document-browser");
export default React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  hasAnyOtherDocumentsFromLoad(tmsCustomerLoad, documentId) {
    return _.any(
      tmsCustomerLoad.documents,
      (document) => document.id !== documentId && this.props.allDocumentIds.includes(document.id)
    );
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__assign-documents-selector") }, "Choose the customer load this document is for:", _.map(this.props.tmsCustomerLoads, this.customerLoad));
  },
  customerLoad: function(tmsCustomerLoad, i) {
    const documentId = this.props.document.id;
    const isChecked = _.some(
      tmsCustomerLoad.documents,
      (document) => document.id === documentId
    );
    const isDisabled = !isChecked && this.hasAnyOtherDocumentsFromLoad(tmsCustomerLoad, documentId);
    const onChange = _.partial(
      this.props.toggleCustomerLoadDocument,
      tmsCustomerLoad,
      this.props.document
    );
    const cssClasses = bem({
      "__assign-documents-selector-label": true,
      "__assign-documents-selector-item-label--disabled": isDisabled
    });
    return /* @__PURE__ */ React.createElement("div", { key: "customer-load-" + i }, /* @__PURE__ */ React.createElement("label", { className: cssClasses }, i + 1 + ")", "\xA0", /* @__PURE__ */ React.createElement(
      "input",
      {
        className: bem("__assign-documents-selector-checkbox"),
        checked: isChecked,
        onChange,
        type: "checkbox"
      }
    ), "\xA0", this.customerLoadMetadata(tmsCustomerLoad)));
  },
  customerLoadMetadata(tmsCustomerLoad) {
    let customerNameText = "";
    if (!_.isEmpty(tmsCustomerLoad.tms_customer)) {
      customerNameText = " for " + tmsCustomerLoad.tms_customer.name;
    }
    const accountSettings = Api.Account.currentSettings();
    let refValue;
    if (accountSettings.primary_shipment_reference_label) {
      refValue = tmsCustomerLoad.references[accountSettings.primary_shipment_reference_label];
    } else {
      refValue = tmsCustomerLoad.customer_load_id;
    }
    return refValue + customerNameText;
  }
});
